import React from 'react';
import DashboardLayout from '../../components/dashboard/DashboardLayout';
import BlogManager from '../../components/dashboard/BlogManager';

const BlogManagerPage = () => {
  return (
    <DashboardLayout>
      <BlogManager />
    </DashboardLayout>
  );
};

export default BlogManagerPage;
